// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "hoc-academy-6ebe2.firebaseapp.com",
  "projectId": "hoc-academy-6ebe2",
  "storageBucket": "hoc-academy-6ebe2.appspot.com",
  "messagingSenderId": "817413821250",
  "appId": "1:817413821250:web:a1d435ada79aa4f4406edb",
  "measurementId": "G-EVJ6F6EE87",
  "apiKey": "AIzaSyDPCVHTfsDK7XaK0uU4VeoZM8K7MDxgqG8"
};
